import Cookie from './Cookie';
import { IsServerSideRendering, IsLocalStorageEnabled } from '../utilities';
import GeolocationApi from './GeolocationApi';

const defaultGeolocation = {
  stateAbbreviation: 'KS',
  city: 'Lebanon',
  zip5: '66952'
};

function getGeolocationFromCookie() {
  if (IsServerSideRendering) {
    return null;
  }

  return {
    state: Cookie.getCookie('CVCurrentState'),
    city: Cookie.getCookie('CVCurrentCity'),
    zip5: Cookie.getCookie('CVCurrentZip')
  };
}

function setGeolocationCookie(response) {
  if (IsServerSideRendering) return response;

  const stateAbbreviation = response.stateAbbreviation || defaultGeolocation.stateAbbreviation;
  Cookie.setCookie('CVCurrentState', stateAbbreviation);

  const zip5 = response.zip5 || defaultGeolocation.zip5;
  Cookie.setCookie('CVCurrentZip', zip5);

  const city = response.city || defaultGeolocation.city;
  Cookie.setCookie('CVCurrentCity', city);

  const localStorageObject = {
    State: stateAbbreviation,
    City: city,
    Zip5: zip5
  };

  const json = JSON.stringify(localStorageObject);

  if (IsLocalStorageEnabled) {
    localStorage.setItem('Geolocation', json);
  }
  return response;
}

function setGeolocation() {
  if (Cookie.getCookie('CVCurrentZip')) {
    return new Promise(resolve => resolve(getGeolocationFromCookie()));
  }

  return GeolocationApi.fetchGeolocation()
    .then(setGeolocationCookie)
    .catch(() => {
      setGeolocationCookie(defaultGeolocation);
    });
}

export default {
  setGeolocation
};
